import React, { useMemo, useEffect, useState } from "react";
import { Marker, useMap } from "react-leaflet";
import Supercluster from "supercluster";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "../../../static/styles/markerCluster.css";
import LeakPopup from "./Popups/LeakPopup";

const MarkerCluster = ({ points, onMarkerClicked }) => {
  const map = useMap();
  const [clusters, setClusters] = useState([]);
  const [mapBounds, setMapBounds] = useState(map.getBounds());
  const [zoom, setZoom] = useState(map.getZoom());

  const supercluster = useMemo(() => {
    const instance = new Supercluster({
      radius: 60,
      maxZoom: 15,
    });
    if (points?.length) {
      instance.load(points);
    }
    return instance;
  }, [points]);

  const createClusterIcon = (cluster) => {
    return L.divIcon({
      html: `<span>${cluster.properties.point_count}</span>`,
      className: "marker-cluster-custom",
      iconSize: L.point(40, 40, true),
    });
  };

  useEffect(() => {
    const updateClusters = () => {
      const bounds = map.getBounds();
      setMapBounds(bounds);
      setZoom(map.getZoom());
    };
    map.on("moveend", updateClusters);
    updateClusters();
    return () => {
      map.off("moveend", updateClusters);
    };
  }, [map]);

  useEffect(() => {
    if (supercluster.points) {
      const newClusters = supercluster.getClusters(
        [
          mapBounds.getWest(),
          mapBounds.getSouth(),
          mapBounds.getEast(),
          mapBounds.getNorth(),
        ],
        zoom
      );
      setClusters(newClusters);
    }
  }, [supercluster, mapBounds, zoom]);

  return (
    <>
      {clusters.map((point) => {
        const [longitude, latitude] = point.geometry.coordinates;
        if (point.properties.cluster) {
          return (
            <Marker
              key={`cluster-${point.id}`}
              position={[latitude, longitude]}
              icon={createClusterIcon(point)}
              eventHandlers={{
                click: () => {
                  const expansionZoom = supercluster.getClusterExpansionZoom(
                    point.id
                  );
                  map.setView([latitude, longitude], expansionZoom, {
                    animate: true,
                  });
                },
              }}
            />
          );
        }
        return (
          <Marker
            key={`point-${point.id}`}
            position={[latitude, longitude]}
            icon={point.icon}
            eventHandlers={{
              click: (e) => {
                L.DomEvent.stopPropagation(e);
                onMarkerClicked(point);
              },
              mouseover: (e) => {
                e.target.openPopup();
              },
              mouseout: (e) => {
                e.target.closePopup();
              },
            }}
          >
            <LeakPopup
              feature={point}
              onClick={() => onMarkerClicked(point)}
            />
          </Marker>
        );
      })}
    </>
  );
};

export default MarkerCluster;
